import { numberComparatorMax2, numberFilterParams, createNumberFormatter } from "@icarius-table/number";
import { getLocalizedString } from "@icarius-localization/strings";

export default () => [
    //////////////////////activitiesByTraining
    {
        pages: ["activitiesByTraining"],
        config:
        {
            headerName: getLocalizedString("activityName"),
            field: "activityName",
            filter: "agSetColumnFilter",
            chartDataType: "series",
            checkboxSelection: function (params) {
                // we put checkbox on the name if we are not doing grouping
                return params.columnApi.getRowGroupColumns().length === 0;
            },
            headerCheckboxSelection: function (params) {
                // we put checkbox on the name if we are not doing grouping
                return params.columnApi.getRowGroupColumns().length === 0;
            },
            headerCheckboxSelectionFilteredOnly: true,
            enableRowGroup: true,
        }
    },
    {
        pages: ["activitiesByTraining"],
        config:
        {
            headerName: getLocalizedString("participantCode"),
            field: "participantCode",
            filter: "agSetColumnFilter",
        }
    },
    {
        pages: ["activitiesByTraining"],
        config:
        {
            headerName: getLocalizedString("participantName"),
            field: "participantName",
            filter: "agTextColumnFilter",
        }
    },
    {
        pages: ["activitiesByTraining"],
        config:
        {
            headerName: getLocalizedString("activityFinished"),
            field: "activityFinished",
            filter: "agSetColumnFilter",
        }
    },
    //////////////////////participantsByTraining
    {
        pages: ["participantsByTraining"],
        config:
        {
            headerName: getLocalizedString("code"),
            field: "code",
            filter: "agTextColumnFilter",
            chartDataType: "series",
            checkboxSelection: function (params) {
                // we put checkbox on the name if we are not doing grouping
                return params.columnApi.getRowGroupColumns().length === 0;
            },
            headerCheckboxSelection: function (params) {
                // we put checkbox on the name if we are not doing grouping
                return params.columnApi.getRowGroupColumns().length === 0;
            },
            headerCheckboxSelectionFilteredOnly: true,
            enableRowGroup: true,
        }
    },
    {
        pages: ["participantsByTraining"],
        config:
        {
            headerName: getLocalizedString("name"),
            field: "name",
            filter: "agTextColumnFilter",
        }
    },
    {
        pages: ["participantsByTraining"],
        config:
        {
            headerName: getLocalizedString("activitiesFinished"),
            field: "activitiesFinished",
            filter: "agTextColumnFilter",
            comparator: numberComparatorMax2,
            filterParams: numberFilterParams(),
            chartDataType: "series",
            cellClass: "currencyValue",
            valueFormatter: createNumberFormatter(0, 0),
            enableValue: true,
            allowedAggFuncs: ["sum", "min", "max", "avg"],
        }
    },
    {
        pages: ["participantsByTraining"],
        config: {
            headerName: getLocalizedString("progress"),
            field: "progress",
            cellRenderer: "ProgressRenderer",
            filter: "ProgressFilter",
            cellClass: "percentageValue",
        }
    },
]